import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { useHistory } from "react-router-dom"
// offer Redux States
import {
  QA_GET_OFFERS_LISTING,
  QA_OFFER_EDIT,
  QA_OFFER_UPDATE,
} from "./actionTypes"
import {
  qaOffersListingSuccess,
  qaOffersListingFail,
  qaEditOfferSuccess,
  qaEditOfferFail,
  qaUpdateOfferSuccess,
  qaUpdateOfferFail,
} from "./actions"

import {
  qaOffersListingApi,
  qaEditOfferApi,
  qaUpdateOfferApi,
} from "../../../helpers/fakebackend_helper"

function* qaGetOfferListing() {
  try {
    const response = yield call(qaOffersListingApi)
    if (
      response.results === undefined ||
      response.results.prod_offers.length == 0
    ) {
      throw response.msg ? response.msg : "No data found"
    }
    yield put(qaOffersListingSuccess(response.results.prod_offers))
  } catch (error) {
    yield put(qaOffersListingFail(error))
  }
}

function* qaGetOfferDetailsById({ payload: { id } }) {
  try {
    const response = yield call(qaEditOfferApi, id)
    if (response && response.status) {
      response.id = id
      yield put(qaEditOfferSuccess(response.results.offer_details))
    } else {
      throw response.msg ? response.msg : "Failed to fetch offer details"
    }
  } catch (error) {
    yield put(qaEditOfferFail(error))
  }
}

function* qaOnUpdateOffer({ payload: { offer, history } }) {
  try {
    const response = yield call(qaUpdateOfferApi, offer)
    if (response && response.status) {
      yield put(qaUpdateOfferSuccess(response))
      history.push("/offers/list")
    } else {
      throw response.msg ? response.msg : "Failed to update offer"
    }
  } catch (error) {
    yield put(qaUpdateOfferFail(error))
  }
}

function* qaofferSaga() {
  yield takeEvery(QA_GET_OFFERS_LISTING, qaGetOfferListing)
  yield takeEvery(QA_OFFER_EDIT, qaGetOfferDetailsById)
  yield takeEvery(QA_OFFER_UPDATE, qaOnUpdateOffer)
}
export default qaofferSaga
